<template>
  <nav class="header-navbar main-header-navbar navbar-expand-lg navbar navbar-with-menu fixed-top navbar-dark">
    <div class="navbar-wrapper">
      <div class="navbar-container content">
        <div id="navbar-mobile" class="navbar-collapse">
          <div class="mr-auto float-left bookmark-wrapper d-flex align-items-center">
            <ul class="nav navbar-nav">
              <li class="nav-item mobile-menu d-xl-none mr-auto">
                <a class="nav-link nav-menu-main menu-toggle hidden-xs" href="javascript:void(0);">
                  <i class="ficon bx bx-menu"></i></a></li>
            </ul>
            <ul class="nav navbar-nav bookmark-icons">
              <li class="nav-item d-none d-lg-block">
                <div class="custom-control custom-switch">
                  <input id="geceModu" class="custom-control-input" type="checkbox">
                  <label class="custom-control-label" for="geceModu">
                    <span class="switch-icon-left"><i class="bx bx-moon"></i></span>
                    <span class="switch-icon-right"><i class="bx bxs-sun"></i></span>
                  </label>
                </div>
              </li>
            </ul>
            <ul class="nav navbar-nav">
            </ul>
          </div>
          <ul class="nav navbar-nav float-right">
            <KTDropdownLanguage
                v-on:language-changed="onLanguageChanged"
            ></KTDropdownLanguage>

            <li class="dropdown dropdown-notification nav-item">
              <a aria-expanded="false" class="nav-link nav-link-label"
                 data-toggle="dropdown" href="javascript:void(0);">
                <i class="ficon bx bx-bell bx-tada bx-flip-horizontal"></i>
                <span v-if="count" class="badge badge-pill badge-danger badge-up"> {{ count }}</span>
              </a>
              <ul class="dropdown-menu dropdown-menu-media dropdown-menu-right">
                <li class="dropdown-menu-header">
                  <div class="dropdown-header px-1 py-75 d-flex justify-content-between">
                    <span class="notification-title">{{ count }} {{ $t('general.new_notification') }}</span>
                    <span v-if="false" class="text-bold-400 cursor-pointer">Tümünü okundu olarak işaretle</span>
                  </div>
                </li>
                <li class="scrollable-container media-list overflow-scroll">
                  <template v-for="(item, i) in items">
                    <a class="d-flex justify-content-between" href="javascript:void(0);"
                       @click.prevent="onClickNotification(item)">
                      <div class="media d-flex align-items-center">
                        <div class="media-body">
                          <h6 :class="!item.read_at ? 'font-weight-bold' : ''" class="media-heading">
                            {{ item.title }}
                          </h6>
                          <small :class="!item.read_at ? 'font-weight-bold' : ''" class="notification-text">
                            {{ fixDateToNow(item.created_at) }}
                          </small>
                        </div>
                      </div>
                    </a>
                  </template>
                </li>

                <li v-if="count === 0" class="scrollable-container media-list overflow-scroll">
                  <a class="d-flex justify-content-between" href="javascript:void(0);">
                    <div class="media d-flex align-items-center">
                      <div class="media-body">
                        <h6 class="media-heading">
                          {{ $t('general.no_notification') }}
                        </h6>
                      </div>
                    </div>
                  </a>
                </li>

                <li class="dropdown-menu-footer">
                  <a v-if="false" class="dropdown-item p-50 text-primary justify-content-center"
                     href="javascript:void(0)">
                    Tümünü görüntüle
                  </a>
                </li>
              </ul>
            </li>
            <li class="dropdown dropdown-user nav-item">
              <a class="dropdown-toggle nav-link dropdown-user-link" data-toggle="dropdown" href="javascript:void(0);">
                <div class="user-nav d-sm-flex d-none">
                  <span class="user-name">{{ user ? user.name + ' ' + user.surname : '' }}</span>
                  <span class="user-status text-muted">{{ user ? user.title : '' }}</span>
                </div>
                <span>
                  <img :src="user ? user.photo_link : ''" alt="avatar" class="round" height="40" width="40">
                </span>
              </a>
              <div class="dropdown-menu dropdown-menu-right pb-0">
                <a v-if="false" class="dropdown-item" href="profile.html"><i class="bx bx-user mr-50"></i> PROFİL</a>
                <div v-if="false" class="dropdown-divider mb-0"></div>
                <a class="dropdown-item" href="#" @click.prevent="onLogout"><i class="bx bx-power-off mr-50"></i>
                  {{ $t('general.logout') }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

</template>

<script>
import KTDropdownLanguage from "@/view/layout/extras/dropdown/DropdownLanguage.vue";
import KTTopbar from "@/view/layout/header/Topbar.vue";
import KTMenu from "@/view/layout/header/Menu.vue";
import i18nService from "@/core/services/i18n.service.js";
import {LOGOUT} from "@/core/services/store/auth.module";
import moduleUser, {MODULE_NAME as MODULE_USER, SELF} from "@/core/services/store/user.module";
import baseModule, {
  BASE_URL,
  COUNT,
  GET_COUNT,
  GET_ITEMS,
  ITEMS,
  MODULE_NAME as BASE_MODULE,
  UPDATE_ITEM
} from "@/core/services/store/notification.module";

import store from "@/core/services/store";
import moment from "moment";

const _BASE_MODULE = BASE_MODULE;
const _MODULE_USER = MODULE_USER;

export default {
  name: "KTHeader",
  components: {
    KTTopbar,
    KTMenu,
    KTDropdownLanguage
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_BASE_MODULE, baseModule);
    registerStoreModule(_MODULE_USER, moduleUser);
  },
  data() {
    return {
      languageFlag: "",
      languages: i18nService.languages
    };
  },
  methods: {
    onLanguageChanged() {
      this.languageFlag = this.languages.find(val => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    },
    fixDateToNow(value) {
      return moment(value).fromNow();
    },
    onLogout() {
      this.$store
          .dispatch(LOGOUT)
          .then(() => this.$router.push({name: "login"}));

      setTimeout(() => {
        window.location.reload();
      }, 500);
    },
    getNotificationCount() {
      this.$store.dispatch(_BASE_MODULE + '/' + GET_COUNT, {});
    },
    onClickNotification(item) {
      if (item && item.route) {
        this.readNotification(item)

        if (item && item.route) {
          this.$router.push(item.route);
        }

        return false;
      }
    },
    filterResults() {
      this.$store.dispatch(_BASE_MODULE + '/' + GET_ITEMS, {});
    },
    readNotification(item) {
      let url = BASE_URL + '/' + item.id;
      this.$store.dispatch(_BASE_MODULE + '/' + UPDATE_ITEM, {
        url: url,
      });

      this.filterResults()

      this.getNotificationCount();
    },
  },
  mounted() {
    this.getNotificationCount();

    this.filterResults();

    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
      let name = cname + "=";
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    $(document).ready(function () {
      $('#geceModu').change(function () {
        if (this.checked) {
          setCookie('geceModu', 'active', 1)
          $('body').addClass('dark-layout');
          $('.main-menu').removeClass('menu-light').addClass('menu-dark')
          $('.brand-logo img').attr('src', 'app-assets/images/icon-dark.png')
          $('.brand-text img').attr('src', 'app-assets/images/logo-dark.png')
        } else {
          //günduz modu
          setCookie('geceModu', 'passive', 1)
          $('body').removeClass("dark-layout");
          $('.main-menu').removeClass('menu-dark').addClass('menu-light')
          $('.brand-logo img').attr('src', 'app-assets/images/icon-light.png')
          $('.brand-text img').attr('src', 'app-assets/images/logo-light.png')
        }
      });
    })

    if (getCookie('geceModu') === "active") {
      $('#geceModu').attr('checked', true);
      $('body').addClass('dark-layout');
      $('.main-menu').removeClass('menu-light').addClass('menu-dark')
      $('.brand-logo img').attr('src', 'app-assets/images/icon-dark.png')
      $('.brand-text img').attr('src', 'app-assets/images/logo-dark.png')
    } else {
      setCookie('geceModu', 'passive')
      $('#geceModu').attr('checked', false);
      $('body').removeClass("dark-layout");
      $('.main-menu').removeClass('menu-dark').addClass('menu-light')
      $('.brand-logo img').attr('src', 'app-assets/images/icon-light.png')
      $('.brand-text img').attr('src', 'app-assets/images/logo-light.png')
    }
  },
  computed: {
    count() {
      let countData = store.getters[_BASE_MODULE + "/" + COUNT];

      if (countData && countData.hasOwnProperty('count')) {
        return countData.count;
      }

      return 0;
    },
    user() {
      let user = this.$store.getters[_MODULE_USER + '/' + SELF];
      return user && user.hasOwnProperty('user') ? user.user : null;
    },
    items() {
      let results = [];
      let items = store.getters[_BASE_MODULE + "/" + ITEMS] || [];

      if (items) {
        items.forEach(item => {
          let data = JSON.parse(item.data);
          results.push({
            id: item.id,
            message: data.message,
            read_at: item.read_at,
            created_at: item.created_at,
            title: data.title,
            route: data.web_params,
            color: "primary",
            svg: process.env.BASE_URL + "media/svg/icons/Home/Library.svg"
          })
        })
      }

      return results;
    },
  },
};
</script>
